export { default as FooterConnectFragments } from './footer-connect-fragments';
